export const FOTT_SERVICE_REQUEST_FIELDS = Object.freeze({
  SERVICE_TYPE: "serviceType",
  BOOKING_FROM: "bookingFrom",
  BOOKING_TO: "bookingTo",
  STARTING_FROM: "startingFrom",
  START_TIME: "startTime",
  USAGE_HOURS: "usageHours",
  MATRIX_MANIFOLD: "matrixManifold",
  ON_BEHALF_OF_COMPANY: "onBehalfOfCompany",
  ON_BEHALF_OF_COMPANY_OTHER: "onBehalfOfCompanyOther",
  CHARGEABLE_PARTY: "chargeableParty",
  CHARGEABLE_PARTY_OTHER: "chargeablePartyOther",
  CHARGEABLE_PARTY_SAME_AS_ON_BEHALF: "chargeablePartySameAsOnBehalf",
  OPERATOR_NEEDED: "operatorNeeded",
  CUSTOMER_JL_SLOT_SIZE: "customerJlSlotSize",
  CUSTOMER_JL_NO: "customerJlNo",
  CUSTOMER_TANK_NO: "customerTankNo",
  FOTT_DOCK_LINE_NO_SIZE: "fottDockLineNoSize",
  FOTT_DOCK_LINE: "fottDockLine",
  PRODUCT_TYPE: "productType",
  USAGE_REASON: "usageReason",
  REMARKS: "remarks",
  OPERATOR_LICENSE: "operatorLicense",
  DATE_TIME: "dateTime",
  LOCATION: "location",
  VESSEL_IMO: "vesselImo",
  VESSEL_NAME: "vesselName",
  TERMINAL: "terminal",
  OPERATION_TYPE: "operationType",
  DOCK_LINE: "dockLine",
  MOV_NUMBER: "movNumber",
  PLTA: "plta",
  PLDA_NUMBER: "pldaNumber",
  REASON_FOR_BYPASS: "reasonForBypass",
  EXPECTED_TIME_OF_CLOSURE: "expectedTimeOfClosure",
  PHYSICAL_VERIFICATION_OF_VALVE_TAG: "physicalVerificationOfValveTag",
  COLLECTION_OF_VALVE_KEY: "collectionOfValveKey",
  REMOVAL_OF_PADLOCK: "removalOfPadlock",
  CROSS_CHECK_COMMUNICATION: "crossCheckCommunication",
  CONFIRMATION_OF_INSTRUCTIONS_CUSTOMER: "confirmationOfInstructionsCustomer",
  CONFIRMATION_OF_INSTRUCTIONS_FOTT: "confirmationOfInstructionsFott",
  ATTACHMENT: "attachments",
} as const);

export const OTHER_COMPANY_VALUE = "OTHER";
export const FOTT_SERVICE_REQUEST_FORM_STORAGE_KEY = "fott-service-request-form";
export const MAX_GANTRY_CRANE_TEXT_LENGTH = 500;
export const MAX_NITROGEN_TEXT_LENGTH = 500;
export const MAX_NITROGEN_SHORT_TEXT_LENGTH = 50;
export const MAX_NITROGEN_USAGE_HOURS_DIGITS = 3;
export const MAX_PIGGING_TEXT_LENGTH = 500;
export const MAX_PIGGING_SHORT_TEXT_LENGTH = 50;
export const MAX_PIGGING_TANK_NO_LENGTH = 30;
export const MAX_FOTT_SERVICE_REMARKS_LENGTH = 1000;
export const MAX_VESSEL_IMO_LENGTH = 7;
export const MAX_BYPASS_SHORT_TEXT_LENGTH = 30;
export const MAX_BYPASS_TEXT_LENGTH = 500;
export const MAX_BYPASS_ATTACHMENTS = 25;
export const MAX_OPERATOR_LICENSE_FILES = 1;
export const MAX_NITROGEN_ATTACHMENTS = 25;
export const MAX_PIGGING_ATTACHMENTS = 25;
export const MAX_GANTRY_ATTACHMENTS = 25;
export const OPERATOR_LICENSE_DOCUMENT_TYPE = "OPERATOR_LICENSE";
export const FOTT_FROM_TO_LOCATION = "FOTT";

export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES = [
  "CERTIFICATE",
  "PERMIT",
  "DOCUMENT",
  "INSURANCE",
  "VESSEL_MASTER_SOF",
  "OTHERS",
] as const;

export const terminalServiceDocumentTypeOptions = [
  { label: "Certificate", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[0] },
  { label: "Permit", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[1] },
  { label: "Document", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[2] },
  { label: "Insurance", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[3] },
  { label: "Vessel Master-SoF", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[4] },
  { label: "Others-Specify", value: TERMINAL_SERVICE_ATTACHMENT_DOCUMENT_TYPES[5] },
];
